import { Button, Flex, HStack, Spacer, Text } from "@chakra-ui/react";
import React from "react";
import { NavLink } from 'react-router-dom';


export const UpgradePrompt = ({ message }) => {
    if (!message) return null;
    return (
        <Flex w="full">
            <HStack
                bgGradient="linear(to-l, #D6E0FF, #E6F9FE)"
                w="full"
                borderColor="#CDDCF7"
                borderWidth="1px"
                borderRadius={8}
                py="8px"
                px="12px"
                alignItems="flex-start"
            >
                <img src="https://ik.imagekit.io/ikmedia/upgrade-icon.svg" alt="Upgrade Icon" />
                <Flex direction="column">
                    <Text
                        style={{
                            lineBreak: 'anywhere',
                        }}
                        fontWeight="semibold"
                    >
                        It’s time to upgrade!
                    </Text>
                    <Text
                        style={{
                            lineBreak: 'anywhere',
                        }}
                    >
                        {message}
                    </Text>
                </Flex>
                <Spacer />
                <Button
                    as={NavLink}
                    minW="100px"
                    colorScheme="appSemanticSearch"
                    fontWeight="500"
                    alignSelf="center"
                    to="/upgrade-plan"
                    _hover={{
                        textDecoration: 'none',
                    }}
                >
                    <Text>Upgrade now</Text>
                </Button>
            </HStack>
        </Flex>
    );
};
